import Vuex from "vuex"
import Vue from "vue"

// import moduleName from './modules/{moduleName}/store.js'
import module from "./modules/module/store"
import notificationModule from "./modules/notification/store"
import xpConditions from "./modules/xpConditions/store"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // add your modules here
    module,
    notificationModule,
    xpConditions,
  },
})
